import { getMixpanel } from '../../api/mixpanel'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'

const mixpanel = getMixpanel()

/*

  Event names:
  - A01 Login
  - A02 Logout
  - A10 Signup (email)
  - A11 Signup (google)
  - A20 Forgot password
  - A21 Reset password

  - O01 Onboarding started

  - D01 Dashboard viewed
  - D10 Deep Dive Viewed
  - D20 Raw Data Viewed
  - D30 Query Viewed
  - D40 Audience Viewed
  - D50 Forms Viewed

  - I01 Integration started
  - I02 Integration Javascript clicked
  - I03 Integration iOS Swift clicked
  - I04 Integration Android clicked

  */

const locationMap = {
  '/': 'L00 Homepage',
  '/login': 'A01 Login',
  '/logout': 'A02 Logout',
  '/signup': 'A10 Signup (email)',
  '/signup/google': 'A11 Signup (google)',
  '/forgot-password': 'A20 Forgot password',
  '/onboarding': 'O01 Onboarding started',
  '/dashboard': 'D01 Dashboard viewed',
  '/dashboard/deep-dive': 'D10 Deep Dive Viewed',
  '/dashboard/raw-data': 'D20 Raw Data Viewed',
  '/dashboard/query': 'D30 Query Viewed',
  '/dashboard/audience': 'D40 Audience Viewed',
  '/dashboard/forms': 'D50 Forms Viewed',
  '/dashboard/integration': 'D60 Dashboard Integration',
  '/dashboard/audience-manager': 'D70 Audience Manager',
  '/onboarding/': 'O00 Onboarding Started',
  '/onboarding/project': 'O20 Onboarding Project Name',
  '/onboarding/audience': 'O30 Onboarding Audience',
  '/onboarding/form': 'O40 Onboarding Form',
  '/onboarding/sdk': 'O50 Onboarding SDK'
}

const trackPageView = (page) => {
  console.log('tracking page view', page, locationMap[page])
  try {
    if (page.indexOf('/form/') === 0) {
      const accountId = page.split('/')[2]
      const formId = page.split('/')[3]
      const userId = page.split('/')[4]

      mixpanel.track('Form Viewed', {
        page: page || window.location.pathname,
        url: window.location.href,
        referrer: document.referrer || 'direct',
        accountId,
        formId,
        userId
      })
    } else {
      mixpanel.track(locationMap[page] || 'Page View', {
        page: page || window.location.pathname,
        url: window.location.href,
        referrer: document.referrer || 'direct',
        title: document.title
      })
    }
  } catch (error) {
    console.error('Error tracking page view', error)
  }
}

function PageViewTracker () {
  const location = useLocation()

  useEffect(() => {
    // Track page view when location changes
    trackPageView(location.pathname)
  }, [location])
}

export default PageViewTracker
